import React, { useEffect, useState } from "react";
import axiosInstance from "../api/axiosInstance.ts"; // ✅ Import Axios instance

interface Question {
    question: string;
    questionShorten: string;
    profession: string | null;
    language: string;
    questionNumber: number;
}

interface GroupedQuestions {
    [profession: string]: {
        [language: string]: Question[];
    };
}

const QuestionsPage: React.FC = () => {
    const [questions, setQuestions] = useState<GroupedQuestions>({});
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchQuestions = async () => {
            try {
                const response = await axiosInstance.get<Question[]>("/questions"); // ✅ Use axiosInstance

                const data = response.data;

                // ✅ Group by profession → then by language
                const groupedData: GroupedQuestions = {};

                data.forEach((q) => {
                    const profession = q.profession || "General"; // Handle null professions
                    const language = q.language;

                    if (!groupedData[profession]) groupedData[profession] = {};
                    if (!groupedData[profession][language]) groupedData[profession][language] = [];

                    groupedData[profession][language].push(q);
                });

                setQuestions(groupedData);
            } catch (err) {
                setError((err as Error).message);
            } finally {
                setLoading(false);
            }
        };

        fetchQuestions();
    }, []);

    if (loading) return <div>Loading questions...</div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div>
            <h2>Questions</h2>
            {Object.entries(questions).map(([profession, languages]) => (
                <div key={profession} style={{ marginBottom: "30px" }}>
                    <h3>{profession}</h3>

                    {Object.entries(languages).map(([language, questionsList]) => (
                        <div key={language} style={{ marginLeft: "10px" }}>
                            <h4>Language: {language.toUpperCase()}</h4>
                            <ul>
                                {questionsList.map((q) => (
                                    <li key={q.questionNumber}>
                                        <strong>{q.questionShorten}:</strong> {q.question}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
};

export default QuestionsPage;
